var _g, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_759_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26,
    fill: "white",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2657 38.3028C27.5647 38.3028 26.4378 38.1836 24.9165 37.4176C21.9905 35.944 19.8126 32.9391 19.8126 29.6309C19.8126 27.9749 19.9459 26.8487 20.6717 25.412C21.3531 24.0621 22.3076 22.7691 23.5766 21.9109C25.5683 20.5635 26.8449 20.2559 29.3437 20.2559C31.2265 20.2559 33.4934 21.2251 34.793 22.463C35.0129 22.6725 35.2192 22.7757 35.4152 23.0126C35.7644 23.4351 36.0803 23.7906 36.3759 24.2392C39.2051 28.528 37.9092 34.3985 33.5305 37.0209C33.3147 37.1499 33.0441 37.3132 32.8267 37.411C31.8575 37.8464 30.6233 38.3028 29.2656 38.3028H29.2657ZM17.3906 28.6934C17.3906 30.9918 17.5334 32.3483 18.5621 34.3969C19.2822 35.8311 19.9051 36.5484 21.0033 37.6589C22.457 39.1293 24.543 40.079 26.564 40.5358C28.785 41.0376 31.6754 40.6944 33.6935 39.6839C35.2611 38.899 35.8547 38.4715 37.0196 37.3069C39.0767 35.2494 40.3593 32.359 40.3593 29.3185C40.3593 26.5331 39.3394 23.962 37.7149 21.9631C37.5932 21.8134 37.4997 21.7454 37.3792 21.5957C37.2295 21.4097 37.2043 21.3541 37.0218 21.1716C36.8551 21.0052 36.8306 20.9935 36.6425 20.8479C35.9664 20.3254 35.6933 19.9174 34.5781 19.3184C34.2415 19.1375 34.0081 18.9701 33.6083 18.8041C28.9797 16.88 24.1911 17.7112 20.9259 20.9788C20.1822 21.7228 20.2489 21.5967 19.5996 22.4649C19.185 23.0192 18.8613 23.5663 18.5363 24.2144C17.9644 25.3554 17.3906 27.0268 17.3906 28.6935V28.6934Z",
    fill: "#00C8C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00004 18.6151V40.0213C7.00004 40.6775 7.38888 41.5681 7.73398 42.0218C9.12666 43.8521 10.7339 43.6152 12.7812 43.6152C14.0453 43.6152 14.5369 41.9775 13.3597 41.3181C12.6922 40.944 10.9465 41.4684 10.1239 40.9601C9.77659 40.7452 9.42202 40.352 9.42202 39.7869V18.7715C9.42202 17.442 10.6571 17.3631 11.531 17.3653C12.567 17.3675 19.9211 17.4672 20.3861 17.3137C20.5566 17.2574 20.8161 17.1045 20.9215 16.9897C21.3582 16.5146 21.332 15.6813 20.8429 15.2412C20.6513 15.0688 20.3943 14.9432 20.047 14.9432H10.7499C8.80354 14.9432 7 16.6716 7 18.6151L7.00004 18.6151Z",
    fill: "#00C8C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9686 16.1152C39.9686 18.1556 42.8232 16.9432 43.8956 17.5793C44.2539 17.7916 44.5779 18.2304 44.5779 18.7715V39.787C44.5779 40.3322 44.2904 40.6515 43.968 40.8956C43.5901 41.1822 43.1862 41.1973 42.5473 41.1938C41.523 41.1885 34.5158 41.0636 34.0502 41.2907C32.8425 41.8796 33.2974 43.6152 34.5781 43.6152H43.1717C45.1518 43.6152 47 41.8362 47 40.0214V18.5372C47 17.2272 46.0005 15.8314 44.7689 15.2994C43.5864 14.7885 42.5114 14.9433 41.0625 14.9433C40.5264 14.9433 39.9686 15.5662 39.9686 16.1152L39.9686 16.1152Z",
    fill: "#00C8C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2657 34.3965C28.1391 34.3965 27.5977 34.426 26.5552 33.9035C26.2702 33.7607 26.0575 33.6263 25.8275 33.4596C25.1549 32.9726 24.5651 32.3195 24.2121 31.5592C23.5377 30.107 23.5137 28.3324 24.264 26.8951C24.9819 25.5203 26.1981 24.6021 27.7006 24.2374C31.0022 23.4365 34.0314 26.1809 34.0314 29.162C34.0314 32.0024 31.7101 34.3964 29.2657 34.3964L29.2657 34.3965ZM21.2188 29.162C21.2188 31.5768 22.4643 34.1489 24.4525 35.4595C24.847 35.7196 25.26 36.0147 25.6813 36.1839C28.7416 37.414 31.8623 37.0088 34.1682 34.6896C39.0305 29.7994 35.6339 21.6622 28.7186 21.6622C25.707 21.6622 23.0079 23.6838 21.9225 26.1162C21.7269 26.555 21.5768 27.0055 21.4519 27.5205C21.3569 27.9125 21.2188 28.6961 21.2188 29.162L21.2188 29.162Z",
    fill: "#00C8C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9063 12.9123C10.9063 14.1509 12.5673 14.6079 13.1742 13.6176C13.9427 12.3631 12.2433 12.4433 15.4376 12.4433C16.069 12.4433 15.3458 14.1622 17.0782 14.1622C17.5947 14.1622 18.172 13.5849 18.172 13.0684V12.5216C18.172 11.212 16.9212 10.0216 15.5937 10.0216C14.0053 10.0216 12.6979 9.78786 11.6651 10.8584C11.2092 11.3312 10.9063 12.012 10.9063 12.9123V12.9123Z",
    fill: "#00C8C1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_759_2",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_759_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_759_2",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.4faba1e2437704135389941168b22060.svg";
export { ForwardRef as ReactComponent };